<template>
    <div>
        <BackButton />

        <div class="inner-content full" v-if="appointment != null">
            <ClientNamesTabs :appointment="appointment" v-model:clientindex="currentClientIndex" />

            <ClientFiche :client="selectedClient" v-if="selectedClient != null" />
        </div>
    </div>
</template>

<script>
import ClientFiche from "@/components/dna/ClientFiche.vue";
import ClientNamesTabs from "@/components/ClientNamesTabs.vue";
import BackButton from "@/components/app/BackButton.vue";
import {apiStore} from "@/stores/api";

export default {
    name:"MeasurementResult",
    components: {
        BackButton,
        ClientFiche,
        ClientNamesTabs

    },
    data() {
        return {
            appointment: null,
            currentClientIndex : 0,
            selectedClient : null,
            printEnabled: true
        };
    },

    async created() {
        this.appointment = await apiStore().getAppointment(this.$route.params.appointment_id);
        const clientid = this.$route.params.clientid;
        if (clientid !== undefined) {
            this.currentClientIndex = this.appointment.clients.findIndex(x => x.id === clientid);
            this.selectedClient = this.appointment.clients[this.currentClientIndex];
        } else {
            this.selectedClient = this.appointment.clients[0];
        }
    },

    watch: {
        currentClientIndex() {
            this.selectedClient = this.appointment.clients[this.currentClientIndex];
        }
    },

    computed: {
        result() {
            return this.selectedClient.measurement_result;
        }
    }

};
</script>

<style lang="scss" scoped>
    .inner-content {
        padding-top: 6.5%;
    }

    .client {
        display: flex;
        justify-content: space-between;
        margin-top : 2rem;

        &--left {
            width : 30%;
            font-size: 1.25em;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            &--bottom {
                .btn-basic {
                    margin-top : .5rem;
                }
            }

            p {
                margin-bottom: 0.5em;
            }

            &--spacer {
                display: inline-block;
                height: 1rem;
            }

            &--name {
                font-weight: bold;
            }
        }

        &--right {
            width : 70%;

        }

        .btn-result {
            margin-right : 1rem;
        }
    }
</style>